module.exports = __webpack_public_path__ + "media/telephone.8a9e5a1c.mp3";